exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-header-cell-label{justify-content:center!important}.slideCustom-enter{transform:translateX(30vw)!important}.slideCustom-enter-active,.slideCustom-leave-active{transition:all .3s ease-in!important}.slideCustom-leave-to,.slideCustom-two-enter{transform:translateX(30vw)!important}.slideCustom-two-enter-active,.slideCustom-two-leave-active{transition:all .3s ease-in!important}.slideCustom-two-leave-to{transform:translateX(30vw)!important}.process .tag-process{margin-right:5px;height:auto!important;font-size:17px!important;padding-left:.35em!important;padding-right:.35em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f79b7a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/DatosFrs.vue
// module id = 2062
// module chunks = 2